(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vueImageWatermark", [], factory);
	else if(typeof exports === 'object')
		exports["vueImageWatermark"] = factory();
	else
		root["vueImageWatermark"] = factory();
})(window, function() {
return 